import IngkaButton, { ButtonProps } from '@ingka/button';
import React, { RefObject } from 'react';

const Button = (
    props: ButtonProps & {
        ref?: RefObject<HTMLAnchorElement | HTMLButtonElement>;
    }
) => <IngkaButton prefix="list-ingka-" {...props} />;

Button.displayName = IngkaButton.displayName; //

export default Button;
